import React, { useEffect, useState } from 'react';
import { CreateUserForm } from 'shared/ui';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { BusinessApi } from 'shared/api';
import { businessStore, userStore } from 'entities/index';
import { validateCreateEmployeeForm } from '../model/validate-create-employee-form';
import { IPointListDto } from 'shared/api/business/interfaces/point-list-dto.interface';
import { ManagerSelector } from './manager-selector';

interface IProps {
  pointId: string;
}

interface IManager {
  accountId: string;
  role: string;
}

export const CreateEmployeeForm: React.FC<IProps> = ({ pointId }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isOnboarding = searchParams.get('onboarding') === 'true';
  const businessId =
    searchParams.get('businessId') || businessStore.businessId || '';
  const [manager, setManager] = useState<IManager>();

  useEffect(() => {
    if (
      isOnboarding &&
      userStore.employeesCount >= userStore.licEmployeeLimit
    ) {
      const path = AppLinks.PointLink.replace(':id', pointId);
      navigate(path, { replace: true });
    }
  }, []);

  if (isOnboarding && userStore.employeesCount >= userStore.licEmployeeLimit) {
    return null;
  }

  return (
    <CreateUserForm
      title="Регистрация сотрудника"
      fioLabel="ФИО сотрудника"
      buttonText="Зарегистрировать сотрудника"
      businessId={businessId}
      navigateLink={AppLinks.PointLink.replace(':id', pointId)}
      hideStandardFields={!!manager}
      extraFields={
        <ManagerSelector
          pointId={pointId}
          setManager={(accountId, role) =>
            setManager(accountId ? { accountId, role } : undefined)
          }
        />
      }
      successMessage="Сотрудник успешно создан"
      onSubmit={async (data) => {
        if (manager) {
          await BusinessApi.accountSetEmployee({
            role: manager.role,
            accountId: manager.accountId,
            pointIds: data.pointIds,
            businessId,
          });
        } else {
          await BusinessApi.createEmployee({
            fio: data.fio.trim(),
            email: data.email,
            phone: data.phone,
            pointIds: data.pointIds,
            password: data.password,
            businessId,
          });
        }
      }}
      validate={(data) => {
        if (manager) return undefined;
        return (
          validateCreateEmployeeForm({
            fio: data.fio,
            email: data.email,
            phone: data.phone,
            password: data.password,
            confirmPassword: data.confirmPassword,
            selectedPoints: data.pointIds.map(
              (id) => ({ id }) as IPointListDto
            ),
          }) ?? undefined
        );
      }}
    />
  );
};
